import React from 'react';
import TenantService from 'App/services/tenant';
var OrderFormConsent = function () {
    return (React.createElement("div", { className: "mt-1 text-muted small" },
        "Klikaj\u0105c \"Zamawiam i p\u0142ac\u0119\" zgadzasz si\u0119 na zakup zawarto\u015Bci koszyka i z poprawno\u015Bci\u0105 wprowadzonych danych. Potwierdzasz te\u017C, \u017Ce jest Ci znany",
        ' ',
        React.createElement("a", { href: TenantService.getTermsOfUseLink(), target: "_blank" }, "regulamin"),
        ' ',
        "oraz",
        ' ',
        React.createElement("a", { href: TenantService.getPrivacyPolicyLink(), target: "_blank" }, "polityka prywatno\u015Bci"),
        ' ',
        TenantService.getBrandName(),
        "."));
};
export default OrderFormConsent;
